/**
 * Course grade analytics.
 */
import React, { Fragment, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";

import { useAsterController } from "context";
import { VText } from "form";
import { mapSectionToGradeDetails } from "utils/grade.util";
import AnalysisGradeLine from "./analysis.grade.line";

/**
 * Lists section grades and pass/fail against the cutoff.
 */
const AnalysisGrade = () => {

  const { t } = useTranslation('common');

  const { courseId } = useParams();

  const [controller] = useAsterController();
  const { courses } = controller;

  const [moduleGrades, setModuleGrades] = useState([]);

  useEffect(() => {
    if (courses && (courses.data || []).length && courseId) {
      const course = (courses.data || []).find(c => c.id === courseId);
      let mapper = mapSectionToGradeDetails(course);
      mapper = mapper.filter(m => m['details'] && m['cutoff'] !== 0);
      setModuleGrades(mapper);
    }
  }, [courses, courseId]);

  return <>
    <VText className="text-2xl mt-8" div>
      {t('Grade Inspect')}
    </VText>
    {
      moduleGrades.map((g, key) => <Fragment key={g.sectionTitle}>
        <div className="text-dark fsp-18 fw-bold mt-3"><VText>{g.sectionTitle}</VText></div>
        <div className="flex mt-2 mb-2 flex-wrap">
          <div className="shadow-lg ml-2 mt-2 flex items-center px-3 py-1 rounded-full uppercase v-bg-body text-sm font-bold">
            <VText color="secondary">{t('Percent')}&nbsp;{g.percent.toFixed(2)} %</VText>
          </div>
          <div className="shadow-lg ml-2 mt-2 flex items-center px-3 py-1 rounded-full uppercase v-bg-body text-sm font-bold">
            <VText color="secondary">{t('Weight')}&nbsp;{g.weight.toFixed(2)} %</VText>
          </div>
          <div className="shadow-lg ml-2 mt-2 flex items-center px-3 py-1 rounded-full uppercase v-bg-body text-sm font-bold">
            <VText color="secondary">{t('Cutoff')}&nbsp;{(g.weight * g.cutoff).toFixed(2)} %</VText>
          </div>
          <div className="shadow-lg ml-2 mt-2 flex items-center px-3 py-1 rounded-full uppercase v-bg-body text-sm font-bold">
            {
              g.is_passed ?
                <div className="text-red-500"><Icon icon="iconoir:security-pass" className="text-xl align-top" />&nbsp;{t('Passed')}</div>
                :
                <div className="text-gray-500"><Icon icon="ic:outline-do-not-disturb-on" className="text-xl align-top" />&nbsp;{t('Not Passed')}</div>
            }
          </div>

        </div>
        <AnalysisGradeLine
          key={key}
          series1={g.details.map(d => d['earned'])}
          series2={g.details.map(d => d['possible'])}
          totalEarned={g.raw_earned}
          totalPossible={g.raw_possible}
        />
      </Fragment>)
    }
  </>;
};

export default AnalysisGrade;